"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var translate_1 = require("utils/translate");
var TenderCard_1 = require("./TenderCard");
var Preview_1 = require("./Preview");
var Types = require("types");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        tender: state.bid.tender,
        user: state.auth.current.user,
        viewportSize: state.viewport.size,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (bid, match) {
        return dispatch(tenderActions.fetchRequest(bid, parseInt(match.params.participantId, 10)));
    },
    fetchSchema: function (folder) {
        return dispatch(tenderActions.fetchSchema(folder.id));
    },
    clear: function () { return dispatch(tenderActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var ViewEnhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetch(this.props.currentBid, this.props.match);
        if (this.props.tender.documents.tenderRoot) {
            this.props.fetchSchema(this.props.tender.documents.tenderRoot);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.tender.status === 'STANDBY' &&
            prevProps.tender.status === 'STANDBY') {
            this.props.fetch(this.props.currentBid, this.props.match);
        }
        if ((!prevProps.tender.documents.tenderRoot &&
            this.props.tender.documents.tenderRoot) ||
            (this.props.tender.documents.tenderRoot &&
                prevProps.tender.documents.tenderRoot &&
                this.props.tender.documents.tenderRoot.id !==
                    prevProps.tender.documents.tenderRoot.id)) {
            this.props.fetchSchema(this.props.tender.documents.tenderRoot);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = ViewEnhance(function (props) {
    var baseUrl = props.baseUrl;
    var selectedLanguage = (0, translate_1.getLanguage)();
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { key: 'preview', path: baseUrl + '/:section/preview/:fileUUID/revision/:revisionUuid', render: function (routeProps) { return (React.createElement(Preview_1.default, __assign({}, routeProps, { baseUrl: routeProps.match.url, rootFolder: 0, currentBid: props.currentBid, currentBriefcase: props.currentBriefcase, BreadCrumb: function (breadcrumbProps) { return (React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bids") }, props.currentBriefcase.name),
                    React.createElement("span", null, props.currentBid.name),
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/participants") }, (0, translation_1.getLocalization)('bid/tenderscard/breadcrumb/participants')),
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/participants/").concat(props.match.params.participantId) }, (0, translation_1.getLocalization)('bid/tenderscard/breadcrumb/tendersCard')),
                    React.createElement("span", null, (0, translation_1.getLocalization)("bid/tenderscard/breadcrumb/tendersCard/".concat(routeProps.match.params.section))),
                    breadcrumbProps.children)); } }))); } }),
        React.createElement(react_router_dom_1.Route, { key: 'view', path: baseUrl, render: function () { return (React.createElement(TenderCard_1.TenderCard, __assign({}, props, { baseUrl: props.baseUrl, currentBid: props.currentBid, currentBriefcase: props.currentBriefcase }))); } })));
});
